import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { useSelector } from "react-redux";
import { checkAccessFn } from "../../../../utils/checkAccess";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { Link } from "react-router-dom";
import Highlighter from "react-highlight-words";

export default function ListDataCompany({
  list = [],
  editData,
  deleteData,
  loading,
  titles = [],
  addData,
  listLoading,
}) {
  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(list);
  console.log(currentList,"current list..................")

  const [searchWords, setSearchWords] = useState([]);

  return (
    <div className="pt-2 uppercase">
      <div className="flex flex-wrap  gap-2 w-full items-center ">
        {checkAccess("Company", "company-create") && (
          <Link to="/dashboard/visa-providers/create">
            <button
              className="p-2 bg-red uppercase text-white rounded-md"
              onClick={addData}
            >
              Add New Visa Provider +
            </button>
          </Link>
        )}
        <Search
          searchKey={["company_id", "name", "email", "mobile"]}
          setSearchWords={setSearchWords}
        />
      </div>
      <p className="text-sm w-full text-right font-medium mb-1 block">{`Slide / scroll to right >`}</p>
      <CountPerPage />

      <div
        className={`grid uppercase grid-cols-table-company auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md`}
      >
        {titles.map((t, index) => (
          <p key={index} className="font-semibold text-base uppercase">
            {t}
          </p>
        ))}
        {listLoading && (
          <div className="flex justify-center items-center gap-3 mt-5 w-full col-span-8">
            <p>Loading</p>
            <CgSpinner className="animate-spin" />
          </div>
        )}
        {!listLoading && <NoDataFound />}

        {!listLoading &&
          currentList.map((l, index) => (
            <React.Fragment key={index}>
              <PaginationIndex index={index} />
              <p>
                <Highlighter
                  searchWords={searchWords}
                  autoEscape={true}
                  textToHighlight={l.name || "-"}
                />
              </p>
              <img src={l.logo} alt="Logo" width={50} className="self-center" />
              <p>
                <Highlighter
                  searchWords={searchWords}
                  autoEscape={true}
                  textToHighlight={l.company_id || "-"}
                />
              </p>
              <p>
                <Highlighter
                  searchWords={searchWords}
                  autoEscape={true}
                  textToHighlight={l.sponsor_id || "-"}
                />
              </p>
              <p>
                <Highlighter
                  searchWords={searchWords}
                  autoEscape={true}
                  textToHighlight={l.authorized_person_name || "-"}
                />
              </p>
              <p>
                <Highlighter
                  searchWords={searchWords}
                  autoEscape={true}
                  textToHighlight={l.company_registration || "-"}
                />
              </p>
              <div className="flex gap-3 min-w-fit ">
                {checkAccess("Company", "company-edit") ? (
                  <button
                    className={
                      listLoading || currentList.length <= 0
                        ? "p-1 px-2 rounded-md ring-1 ring-slate-600 opacity-50"
                        : "p-1 px-2 rounded-md ring-1 ring-slate-600"
                    }
                    onClick={() => editData(l.id)}
                    disabled={
                      loading.edit || listLoading || currentList.length <= 0
                    }
                  >
                    {loading.edit && loading.loadingId === l.id ? (
                      <CgSpinner className="animate-spin mx-auto" />
                    ) : (
                      <CiEdit size={"1.4rem"} />
                    )}
                  </button>
                ) : (
                  <p className="p-1 px-2 rounded-md ring-1 ring-slate-300">
                    --
                  </p>
                )}

                {checkAccess("Company", "company-delete") ? (
                  <button
                    className={
                      listLoading || currentList.length <= 0
                        ? "p-1 px-2 rounded-md ring-1 ring-red text-white bg-red opacity-50"
                        : "p-1 px-2 rounded-md ring-1 ring-red text-white bg-red"
                    }
                    onClick={() =>
                      deleteData((oldState) => ({ open: true, id: l.id }))
                    }
                    disabled={
                      loading.delete || listLoading || currentList.length <= 0
                    }
                  >
                    {loading.delete && loading.loadingId === l.id ? (
                      <CgSpinner className="animate-spin mx-auto" />
                    ) : (
                      <MdDeleteOutline size={"1.4rem"} />
                    )}
                  </button>
                ) : (
                  <p className="p-1 px-2 rounded-md ring-1 ring-slate-300">
                    --
                  </p>
                )}
              </div>
              <hr
                className={`border-[1.5px] border-slate-100  w-full col-span-8 `}
              />
            </React.Fragment>
          ))}
      </div>
      <Pagination />
    </div>
  );
}
